<template>
  <v-card
    flat
    outlined
    class="d-flex justify-center align-center pt-5 pb-1 flex-column fill-height"
    :class="{
      'active-card': isActive,
    }"
    @click="onClick"
    :ripple="{ class: 'd-none' }"
  >
    <div class="active-card-check" v-if="isActive">
      <v-icon color="white" class="check-icon"> mdi-check-bold </v-icon>
    </div>
    <img :src="imgSrc" class="mb-2" />
    <span>{{ label }}</span>
  </v-card>
</template>

<script>
export default {
  name: 'ExternalVideoSource',
  props: {
    imgSrc: {
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  methods: {
    onClick() {
      this.$emit('onClick')
    },
  },
}
</script>

<style scoped>
.fill-height {
  height: 100%;
}

img {
  height: 63.99px;
}

.v-card--link:focus:before {
  opacity: 0;
}

.active-card {
  position: relative;
  color: var(--v-brand-base);
  font-weight: 500;
  border: 2px solid var(--v-brand-base);
  border-radius: 4px;
}

.active-card-check {
  position: absolute;
  top: -1px;
  right: -1px;
  width: 40px;
  height: 40px;
  background: var(--v-brand-base);
  padding: 0px 4px;
  text-align: end;
  color: white;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 50% 50%);
}

.check-icon {
  font-size: 15px;
}
</style>
